import { MenuConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: ActionType.SAVE_TEMP,
        content: i18n.t<string>('另存为模板'),
        respectOffline: true,
    },
];
